// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"cq-z","breadcrumbForward":"dq-z","breadcrumbBack":"eq-z","selected":"fq-z"};